import { ca } from '@cian/analytics';

type TRestore = 'spam' | 'archive';

export function trackRemoveFromSpamClick(restoreType: TRestore, opponentId?: number) {
  ca('eventSite', {
    action: `mark_message_as_${restoreType}_cancel`,
    category: 'Chat',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackCloseNoLinksPopup(opponentId?: number) {
  ca('eventSite', {
    action: 'Close_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackResendErrorMessageClick(opponentId?: number) {
  ca('eventSite', {
    action: 'Correct_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
